import React from 'react';
import { FaAward, FaUsers, FaClock, FaShieldAlt } from 'react-icons/fa';
import './About.css';

const About = () => {
    const highlights = [
        {
            icon: <FaAward />,
            title: '4+ Years',
            description: 'Of Excellence'
        },
        {
            icon: <FaUsers />,
            title: 'We are',
            description: 'Trained Professionals'
        },
        {
            icon: <FaClock />,
            title: '24/7',
            description: 'Service Available'
        },
        {
            icon: <FaShieldAlt />,
            title: '100%',
            description: 'Verified Staff'
        }
    ];

    return (
        <section className="about section" id="about">
            <div className="container">
                <div className="about-content">
                    <div className="about-text">
                        <span className="section-tag">About Adarsh Old Age Care Home Services</span>
                        <h2 className="section-title">
                            Leading Healthcare & <span className="text-gradient">Domestic Services</span> Provider
                        </h2>
                        <p className="about-description">
                            Established in 2021, Adarsh Old Age Care Home Services is a compassionate elder care organization committed to enhancing the quality of life for senior citizens. Founded with the vision of creating a safe, dignified, and nurturing environment for the elderly, Adarsh focuses on delivering personalized care with respect, empathy, and professionalism.
                        </p>
                        <p className="about-description">
                            Based in India, we provide reliable old age care and home support services, ensuring seniors receive the attention, comfort, and companionship they deserve.
                        </p>
                        <p className="about-description">
                            Adarsh Old Age Care Home Services is a leading provider of old age care, elder care services, and senior citizen care in Thane, Mumbai, and Navi Mumbai. We ensure seniors receive the attention, comfort, and companionship they deserve.
                        </p>
                        <div className="about-mission">
                            <h3>Our Mission</h3>
                            <p>
                                At Adarsh, we believe that aging should be embraced with dignity. Whether it is daily assistance, health monitoring, or emotional support, we strive to create a home-like atmosphere where seniors feel secure, valued, and cared for—just like family.
                            </p>
                        </div>
                    </div>

                    <div className="about-highlights">
                        {highlights.map((item, index) => (
                            <div className="highlight-card" key={index}>
                                <div className="highlight-icon">{item.icon}</div>
                                <div className="highlight-content">
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;